export default __webpack_public_path__ + "57e448cc0710919eef253835e943e8c8.jpg";